import { useEffect } from "react";
import { useCurrentUser } from "./useCurrentUser";
import { setSentryUser } from "../sentry";

// Attaches the host-provided identity to Sentry so captured errors are
// attributable to a user. Sourced from the same zoid `currentUser` prop the
// rest of the app uses. No-ops when Sentry is disabled (setSentryUser guards on
// the DSN). Call once near the app root.
export function useSentryUser(): void {
  const user = useCurrentUser();
  useEffect(() => {
    setSentryUser(user ? { id: user.id, email: user.email } : null);
  }, [user]);
}
